import { CurvePointDTO } from './curvePointDTO';
import { ProcedureCoordinatePoint } from './procedure-coordinate-point';

export interface ProcedureLeg {
    id:string,
    arclength: number,
    endPoint : ProcedureCoordinatePoint,
    endPointId : number,
    startPoint : ProcedureCoordinatePoint,
    startPointId : number,
    fixPoint : ProcedureCoordinatePoint,
    fixPointId : number,
    isstraightleg : boolean,
    procedurelegid : string,
    procedurePk : number,
    radius : number,
    sequencenumber : number,
    curvePoints : CurvePointDTO[],
    isselected : boolean,
    ismodified : boolean,
    direction: string,
    offset: number,
}

export class ProcedureLegModel implements ProcedureLeg {
  id:string;
  arclength: number;
  endPoint : ProcedureCoordinatePoint;
  endPointId : number;
  startPoint : ProcedureCoordinatePoint;
  startPointId : number;
  fixPoint : ProcedureCoordinatePoint;
  fixPointId : number;
  isstraightleg : boolean = true;
  procedurelegid : string;
  procedurePk : number;
  radius : number;
  sequencenumber : number;
  curvePoints : CurvePointDTO[];
  isselected : boolean;
  ismodified : boolean = false;
  direction: string = "Not Set";
  offset: number = 0.0;
}

export class ProcedurePath implements ProcedureLeg {
  id:string;
  arclength: number;
  endPoint : ProcedureCoordinatePoint;
  endPointId : number;
  startPoint : ProcedureCoordinatePoint;
  startPointId : number;
  fixPoint : ProcedureCoordinatePoint;
  fixPointId : number;
  isstraightleg : boolean = true;
  procedurelegid : string;
  procedurePk : number;
  radius : number;
  sequencenumber : number;
  curvePoints : CurvePointDTO[];
  isselected : boolean;
  ismodified : boolean = false;
  direction: string;
  offset: number;
}

